// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-double"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M7.5 10.125V20.25L12 18.375L16.5 21L21 18.375V8.25L16.5 10.125L12 7.5L7.5 10.125Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 7.5L7.5 10.125V13.875L3 15.75V5.625L7.5 3L12 5.625L16.5 3.75L16.5 10.125L12 7.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 7.5L7.5 10.125V13.875L3 15.75V5.625L7.5 3L12 5.625L16.5 3.75L16.5 10.125L12 7.5Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 17.625V8.25M16.5 10.9V20.25M7.5 20.25V10.125L12 7.5L16.5 10.125L21 8.25V18.375L16.5 21L12 18.375L7.5 20.25Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-double')
export default class MapDoubleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-double',
    }
  }
}
